import { COLORS } from '../../../utils/colors';

export const useReportEditorStyles = () => {
  return {
    header: {
      bgcolor: COLORS.WHITE,
      boxShadow: '0 .125rem .5rem 0 rgba(0, 0, 0, 0.1)',
      height: '3.125rem',
      display: 'flex',
      alignItems: 'center',
      px: '1.25rem',
      position: 'relative',
      zIndex: 1400,
      justifyContent: 'space-between',
    },
    participant: {
      display: 'flex',
      alignItems: 'center',
      ml: '1rem',
    },
    title: {
      marginLeft: '.75rem',
      fontWeight: '600',
      fontSize: '1rem',
    },
    sidebarHangUp: {
      borderRadius: '3.25rem',
      background:
        'linear-gradient(90deg, rgba(255,110,0,1) 0%, rgba(255,158,84,1) 98%)',
    },
    enterMessage: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      bgcolor: COLORS.WHITE,
      px: '.75rem',
      '& .MuiInput-input': {
        height: '2.5rem',
        outline: 'none',
      },
      '& .MuiInput-root:before': {
        outline: 'none',
        border: 'none',
      },
    },
    sendButton: {
      textTransform: 'lowerCase',
      textDecoration: 'underline',
      background: '#fff',
      color: '#050c4e',
      fontWeight: 400,
      marginRight: '1rem',
      '&:hover': {
        backgroundColor: '#fff',
      },
    },
    roomPanel: {
      position: 'relative',
      display: 'block',
    },
    viewsPanel: {
      flex: 1,
      marginLeft: '-1rem',
    },
    chatPanel: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      overflowY: 'scroll',
      height: 'calc(100vh - 9rem)',
    },
    transcriptsPanel: {
      overflowY: 'scroll',
      height: `calc(100vh - 6rem)`,
      width: '100%',
      padding: '1rem 0',
    },
    uploadPanel: {
      width: '100%',
      display: 'block',
      border: `3px dashed  ${COLORS.LIGHT_GRAY}`,
    },
    leftContainer: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    uploadContent: {
      borderRadius: '1rem',
      display: 'block',
      textAlign: 'center',
      border: `3px dashed  ${COLORS.LIGHT_GRAY}`,
      height: 'fit-content',
      padding: '1rem',
      paddingLeft: '10.5rem',
      paddingRight: '10.5rem',
    },
    uploading: {
      borderRadius: '1rem',
      display: 'flex',
      textAlign: 'start',
      border: `1px solid  #c1c1c1`,
      height: 'fit-content',
      padding: '0.8rem',
      width: '36rem',
      alignItems: 'center',
    },
    downloadOption: {
      display: 'block',
      padding: '3rem',
      textAlign: 'center',
      width: '12rem',
      height: '12rem',
      background: COLORS.WHITE,
      borderRadius: '1rem',
      boxShadow: '0 19px 25px 0 rgba(210, 210, 210, 0.1)',
      cursor: 'pointer',
    },
    confirmModal: {
      backgroundColor: '#fff',
      width: '%',
      height: 'auto',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '1rem',
      padding: '1rem',
      paddingLeft: '4rem',
      paddingRight: '4rem',
    },
    navigation: {
      height: 'fit-content',
      color: '#050c4e',
      alignItems: 'center',
    },
    sendReportButton: {
      backgroundColor: COLORS.PRIMARY,
      color: COLORS.WHITE,
      borderRadius: '1rem',
      textTransform: 'none',
      paddingLeft: '1rem',
      paddingRight: '1rem',
      '&:hover': {
        backgroundColor: COLORS.PRIMARY,
      },
    },
    activeTab: {
      color: '#050c4e',
      BorderBottom: '2px solid #050c4e !important',
      textTransform: 'none',
      '&:MuiTabs-indicator': {
        backgroundColor: '#050c4e',
      },
    },
    tab: {
      textTransform: 'none',
    },
    addButton: {
      paddingLeft: '-1rem',
      cursor: 'pointer',
      height: 'fit-content',
      marginTop: 'auto',
      marginBottom: 'auto',
    },
    inputTab: {
      marginLeft: '-2rem',
      borderRadius: '1rem',
      height: '1.8rem',
      border: '2px solid #050c4e',
      marginTop: 'auto',
      marginBottom: 'auto',
      '&: MuiOutlinedInput-root': {
        marginLeft: '-2rem',
        borderRadius: '1rem',
        height: '1.8rem',
        border: '2px solid #050c4e',
        marginTop: 'auto',
        marginBottom: 'auto',
      },
    },
    inputContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    iconButton: {
      cursor: 'pointer',
    },
    exitButton: {
      textTransform: 'none',
      width: '6.2rem',
      padding: '0.2rem',
    },
    downloadIcon: {
      width: '2.55rem',
      height: '2.55rem',
      border: `1px solid ${COLORS.LIGHT_GRAY}`,
      borderRadius: '50%',
    },
    selectContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    select: {
      borderRadius: '1.25rem',
      borderColor: COLORS.MEDIUM_GRAY,
      color: COLORS.MEDIUM_GRAY,
      textTransform: 'none',

      padding: '0 .5rem',
      height: '2.5rem',
      //width: '8rem',
      //minWidth: '14rem',
      width: 'auto',
      minWidth: '12.5rem',
      '& .MuiSelect-select': {
        padding: '.375rem .5rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: COLORS.PRIMARY,
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: COLORS.PRIMARY,
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: COLORS.PRIMARY,
      },
    },
    selectLabel: {
      fontSize: '1rem',
      backgroundColor: 'white',
      px: '.5rem',
    },
    selectTemplate: {
      width: '100%',
      borderRadius: '0.5rem',
      '& .MuiOutlinedInput-root': {
        padding: '.5rem',
      },
    },
    input: {
      width: '100%',
      '& .MuiOutlinedInput-root': {
        borderRadius: '0.5rem',
      },
      '& .MuiInputLabel-root': {
        backgroundColor: 'white',
        padding: '0 0.5rem',
      },
    },
    inputLabel: {
      fontSize: '1rem',
      backgroundColor: 'white',
      px: '.5rem',
    },
    exitIcon: {
      width: '2.55rem',
      height: '2.55rem',
      marginRight: '-0.5rem',
      border: `1px solid ${COLORS.LIGHT_GRAY}`,
      borderRadius: '50%',
    },
  };
};
